// @flow

import React from 'react'

import PlanItem, {
  type PropTypes as PlanItemProps,
} from 'components/molecules/room/PlanItem'

type PropTypes = {
  room: Object,
  todayOK: boolean,
  plans: Array<PlanItemProps>,
  optionList: React.Element<*>,
  searchSessionId: string,
}

export default (props: PropTypes) => (
  <section className="space-main__section-big space-main__planarea">
    <h2 className="space-main__headline-big">{i18n.t('page.room.planList')}</h2>
    <div className="space-plan">
      <ul className="space-plan__list">
        {props.plans.map((plan, i) => (
          <PlanItem
            key={`room_plan_item_${i}`}
            room={props.room}
            {...plan}
            todayOK={props.todayOK}
            searchSessionId={props.searchSessionId}
          />
        ))}
      </ul>
      {props.optionList}
    </div>
  </section>
)



// WEBPACK FOOTER //
// ./src/components/organisms/room/DetailPlanSection/index.jsx